import { useEffect, useState } from "react";
import { useSubjectContext } from "../subjects-context";

export function useFilteredLayerIds(onFilterLayersUpdated?: (layerIds: string[]) => void) {
    const { filterLayers$ } = useSubjectContext();
    const [layerIds, setLayerIds] = useState<string[]>([]);

    useEffect(() => {
        const sub = filterLayers$.subscribe((layerIds) => {
            setLayerIds(layerIds);
            onFilterLayersUpdated?.(layerIds);
        });

        return () => {
            sub.unsubscribe();
        };
    }, [filterLayers$]);

    return {
        layerIds,
        removeLayerId: (removedLayerId: string) => {
            const updatedLayerIds = layerIds.filter((layerId) => layerId !== removedLayerId);
            filterLayers$.next(updatedLayerIds);
        },
        addLayerId: (newLayerId: string) => {
            // Only add if it doesn't already exist
            if (!layerIds.includes(newLayerId)) {
                const updatedLayerIds = [...layerIds, newLayerId];
                filterLayers$.next(updatedLayerIds);
            }
        },
        setLayerIds: (newLayerIds: string[]) => {
            filterLayers$.next(newLayerIds);
        },
    };
}
